/* eslint-disable react/jsx-props-no-spreading */
import React, { useMemo } from 'react';
import { Field } from 'react-final-form';

import { isEmpty } from 'utils/lodash';

import AsyncSearchComponent from './AsyncSearchComponent';
import { PTField } from '../propTypes';

const AsyncSearch = (props) => {
  const { validate, required } = props;

  const validateField = useMemo(() => {
    if (required && isEmpty(validate)) {
      return (value) => isEmpty(value) && 'Обязательное поле';
    }

    return validate;
  }, [validate, required]);

  return <Field {...props} validate={validateField} component={AsyncSearchComponent} />;
};

AsyncSearch.propTypes = {
  ...AsyncSearchComponent.propTypes,
  ...PTField,
};

export default AsyncSearch;
